import moment from 'moment'
import { numberWithCommas } from 'ops2clientlibrary/src/library/regexp'

export default {
  install (Vue) {
    Vue.filter('toDateTime', (value, format = 'YYYY-MM-DD HH:mm:ss') => (
      moment(value).format(format)
    ))

    Vue.filter('toDateTimeUTC', (value, format = 'YYYY-MM-DD HH:mm:ss') => (
      moment.utc(value).format(format)
    ))

    Vue.filter('toDate', (value, format = 'YYYY-MM-DD') => (
      moment(value).format(format)
    ))

    Vue.filter('number', (value, floatSize = 2) => (
      numberWithCommas(parseFloat(value).toFixed(floatSize))
    ))
  }
}



// WEBPACK FOOTER //
// ./src/plugins/globalFilters.js